export function weekdayChipClass(active: boolean): string {
  return (
    `w-auto max-w-none !w-auto !max-w-none rounded-full px-4 py-1 text-[11px] font-semibold transition ` +
    (active ? 'bg-portal-teal text-pure-white' : 'text-portal-teal/70 hover:text-portal-teal')
  );
}

export function weekdayDayClass(): string {
  return 'inline-flex h-8 w-8 !max-w-none items-center justify-center rounded-full p-0 text-[11px] font-semibold';
}

export function setsEqual(left: ReadonlySet<number>, right: ReadonlySet<number>): boolean {
  if (left.size !== right.size) {
    return false;
  }

  let equal = true;
  left.forEach((value) => {
    if (!right.has(value)) {
      equal = false;
    }
  });
  return equal;
}
